import { useQuery } from "@tanstack/react-query";
import { jsonFetch } from "@/lib/api";

type Company = {
  brand1: string;
  brand2: string;
  tagline: string;
};

type SocialItem = {
  name: "facebook" | "instagram" | "youtube" | "twitter" | string;
  url: string;
};

type Contact = {
  address: string;
  phone: string;
  email: string;
  availability: string;
};

type Policy = {
  booking_policy_en: string;
  booking_policy_de: string;
  cancellation_policy_en: string;
  cancellation_policy_de: string;
};

export type SiteInfo = {
  company: Company;
  social: SocialItem[];
  contact: Contact;
  policiy: Policy;
};

export function getSiteInfo(): Promise<SiteInfo> {
  return jsonFetch<SiteInfo>("/api/site-info");
}

export function useSiteInfo() {
  return useQuery({
    queryKey: ["site-info"],
    queryFn: getSiteInfo,
    staleTime: 1000 * 60 * 10,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
